<ngx-spinner class="ngx-spinner-custom" bdColor="rgb(255, 112, 190)" size="medium" color="#00e492" type="ball-scale-pulse" [fullScreen]="true">
  <p style="color: white"> </p>
</ngx-spinner>
